/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InspectionResponse } from './InspectionResponse';
import {
    InspectionResponseFromJSON,
    InspectionResponseFromJSONTyped,
    InspectionResponseToJSON,
    InspectionResponseToJSONTyped,
} from './InspectionResponse';
import type { ObservationResponse } from './ObservationResponse';
import {
    ObservationResponseFromJSON,
    ObservationResponseFromJSONTyped,
    ObservationResponseToJSON,
    ObservationResponseToJSONTyped,
} from './ObservationResponse';
import type { SiteResponse } from './SiteResponse';
import {
    SiteResponseFromJSON,
    SiteResponseFromJSONTyped,
    SiteResponseToJSON,
    SiteResponseToJSONTyped,
} from './SiteResponse';
import type { ObservableItemResponse } from './ObservableItemResponse';
import {
    ObservableItemResponseFromJSON,
    ObservableItemResponseFromJSONTyped,
    ObservableItemResponseToJSON,
    ObservableItemResponseToJSONTyped,
} from './ObservableItemResponse';
import type { AssetResponse } from './AssetResponse';
import {
    AssetResponseFromJSON,
    AssetResponseFromJSONTyped,
    AssetResponseToJSON,
    AssetResponseToJSONTyped,
} from './AssetResponse';
import type { SiteDiggingConditionResponse } from './SiteDiggingConditionResponse';
import {
    SiteDiggingConditionResponseFromJSON,
    SiteDiggingConditionResponseFromJSONTyped,
    SiteDiggingConditionResponseToJSON,
    SiteDiggingConditionResponseToJSONTyped,
} from './SiteDiggingConditionResponse';
import type { InspectionCategoryTypeResponse } from './InspectionCategoryTypeResponse';
import {
    InspectionCategoryTypeResponseFromJSON,
    InspectionCategoryTypeResponseFromJSONTyped,
    InspectionCategoryTypeResponseToJSON,
    InspectionCategoryTypeResponseToJSONTyped,
} from './InspectionCategoryTypeResponse';
import type { CustomerResponse } from './CustomerResponse';
import {
    CustomerResponseFromJSON,
    CustomerResponseFromJSONTyped,
    CustomerResponseToJSON,
    CustomerResponseToJSONTyped,
} from './CustomerResponse';

/**
 * 
 * @export
 * @interface AssetDashboardItemsResponse
 */
export interface AssetDashboardItemsResponse {
    /**
     * 
     * @type {Array<AssetResponse>}
     * @memberof AssetDashboardItemsResponse
     */
    assets?: Array<AssetResponse>;
    /**
     * 
     * @type {Array<SiteResponse>}
     * @memberof AssetDashboardItemsResponse
     */
    sites?: Array<SiteResponse>;
    /**
     * 
     * @type {Array<CustomerResponse>}
     * @memberof AssetDashboardItemsResponse
     */
    customers?: Array<CustomerResponse>;
    /**
     * 
     * @type {Array<InspectionResponse>}
     * @memberof AssetDashboardItemsResponse
     */
    inspections?: Array<InspectionResponse>;
    /**
     * 
     * @type {Array<InspectionCategoryTypeResponse>}
     * @memberof AssetDashboardItemsResponse
     */
    inspectionCategoryTypes?: Array<InspectionCategoryTypeResponse>;
    /**
     * 
     * @type {Array<ObservationResponse>}
     * @memberof AssetDashboardItemsResponse
     */
    observations?: Array<ObservationResponse>;
    /**
     * 
     * @type {Array<ObservableItemResponse>}
     * @memberof AssetDashboardItemsResponse
     */
    observableItems?: Array<ObservableItemResponse>;
    /**
     * 
     * @type {Array<SiteDiggingConditionResponse>}
     * @memberof AssetDashboardItemsResponse
     */
    siteDiggingConditions?: Array<SiteDiggingConditionResponse>;
}

/**
 * Check if a given object implements the AssetDashboardItemsResponse interface.
 */
export function instanceOfAssetDashboardItemsResponse(value: object): value is AssetDashboardItemsResponse {
    return true;
}

export function AssetDashboardItemsResponseFromJSON(json: any): AssetDashboardItemsResponse {
    return AssetDashboardItemsResponseFromJSONTyped(json, false);
}

export function AssetDashboardItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDashboardItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assets': json['assets'] == null ? undefined : ((json['assets'] as Array<any>).map(AssetResponseFromJSON)),
        'sites': json['sites'] == null ? undefined : ((json['sites'] as Array<any>).map(SiteResponseFromJSON)),
        'customers': json['customers'] == null ? undefined : ((json['customers'] as Array<any>).map(CustomerResponseFromJSON)),
        'inspections': json['inspections'] == null ? undefined : ((json['inspections'] as Array<any>).map(InspectionResponseFromJSON)),
        'inspectionCategoryTypes': json['inspectionCategoryTypes'] == null ? undefined : ((json['inspectionCategoryTypes'] as Array<any>).map(InspectionCategoryTypeResponseFromJSON)),
        'observations': json['observations'] == null ? undefined : ((json['observations'] as Array<any>).map(ObservationResponseFromJSON)),
        'observableItems': json['observableItems'] == null ? undefined : ((json['observableItems'] as Array<any>).map(ObservableItemResponseFromJSON)),
        'siteDiggingConditions': json['siteDiggingConditions'] == null ? undefined : ((json['siteDiggingConditions'] as Array<any>).map(SiteDiggingConditionResponseFromJSON)),
    };
}

export function AssetDashboardItemsResponseToJSON(json: any): AssetDashboardItemsResponse {
    return AssetDashboardItemsResponseToJSONTyped(json, false);
}

export function AssetDashboardItemsResponseToJSONTyped(value?: AssetDashboardItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assets': value['assets'] == null ? undefined : ((value['assets'] as Array<any>).map(AssetResponseToJSON)),
        'sites': value['sites'] == null ? undefined : ((value['sites'] as Array<any>).map(SiteResponseToJSON)),
        'customers': value['customers'] == null ? undefined : ((value['customers'] as Array<any>).map(CustomerResponseToJSON)),
        'inspections': value['inspections'] == null ? undefined : ((value['inspections'] as Array<any>).map(InspectionResponseToJSON)),
        'inspectionCategoryTypes': value['inspectionCategoryTypes'] == null ? undefined : ((value['inspectionCategoryTypes'] as Array<any>).map(InspectionCategoryTypeResponseToJSON)),
        'observations': value['observations'] == null ? undefined : ((value['observations'] as Array<any>).map(ObservationResponseToJSON)),
        'observableItems': value['observableItems'] == null ? undefined : ((value['observableItems'] as Array<any>).map(ObservableItemResponseToJSON)),
        'siteDiggingConditions': value['siteDiggingConditions'] == null ? undefined : ((value['siteDiggingConditions'] as Array<any>).map(SiteDiggingConditionResponseToJSON)),
    };
}

